import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { asMaybeasy } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { LicenseInsightPayload } from './Decoder';
import LicenseCard from './LicenseCard';
import ProductLicense from './ProductLicense';

interface Props {
  insightIndex: number;
  licenseInsight: LicenseInsightPayload;
}

function OverallocationLicenseAlert({ insightIndex, licenseInsight }: Props) {
  return asMaybeasy(licenseInsight.overallocatedBy)
    .map((overallocatedBy) => (
      <_OverallocationLicenseAlert
        insightIndex={insightIndex}
        overallocatedBy={overallocatedBy}
        licenseInsight={licenseInsight}
      />
    ))
    .getOrElse(emptyFragment);
}

const _OverallocationLicenseAlert = observer(
  ({
    insightIndex,
    overallocatedBy,
    licenseInsight,
  }: Props & {
    overallocatedBy: number;
  }) => {
    return (
      <LicenseCard>
        <Typography variant="bodyMedium" fontWeight="medium" className="mb-2" color="dark">
          <T kind="You are over allocated by {{count}} license" count={overallocatedBy} />
        </Typography>
        <ProductLicense
          insightIndex={insightIndex}
          productLicenses={licenseInsight.productLicenses}
        />
      </LicenseCard>
    );
  },
);

export default observer(OverallocationLicenseAlert);
